import { VendorJobPage } from "../vendor-job.page";
import { useCentralStore } from "../../../store/Central";

export const VendorJobPageConnected = () => {
	const organizationId = useCentralStore((s) => s.organization?.id ?? "");
	return <VendorJobPage organizationId={organizationId} />;
};
